import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Box, LabelStyled, LazyImage, SpanStyled } from "../../styled/Elements";
import { PdfIcon } from "../../styled/AllImages";

const InfoData = ({
  name,
  label,
  value,
  className,
  text,
  image,
  render,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <InfoDataWrapper className={className} {...rest}>
      <Box className="formEleContainer">
        {label && (
          <LabelStyled wrap="break-spaces" size="15px" color="var(--text2)">
            {t(label)}
          </LabelStyled>
        )}
        <Box className="position-relative w-100">
          {render ? (
            render(text)
          ) : text && !image ? (
            <SpanStyled
              color="var(--text)"
              style={
                [
                  "ContactNumber",
                  "ContactNo",
                  "phone",
                  t("contact_number"),
                ].includes(label)
                  ? { direction: "ltr", unicodeBidi: "isolate" }
                  : {}
              }
            >
              {t(text)}
            </SpanStyled>
          ) : (
            <Box className="d-flex gap-3 align-items-center">
              <LazyImage
                width="50px"
                src={
                  image?.startsWith("app_data") || image?.includes("\\")
                    ? `${process.env.REACT_APP_ASSET_URL}/${image.replace(
                        /\\/g,
                        "/"
                      )}`
                    : image
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = PdfIcon;
                }}
              />

              <SpanStyled color="var(--text)">{t(text)}</SpanStyled>
            </Box>
          )}
        </Box>
      </Box>
    </InfoDataWrapper>
  );
};

export default InfoData;

export const InfoDataWrapper = styled.div`
  width: 100%;
  padding: 9px 25px 9px 25px;
  border-bottom: 1px solid var(--borderLight);
  width: 100%;
  .formEleContainer {
    display: flex;
    padding: 7px 0px 7px 0px;
    margin: 7px 0 7px 0;
    align-items: center;
    gap: 10px;
    & > label {
      min-width: 160px;
    }
    &.inp-white {
      input {
        background-color: var(--white);
      }
    }
  }

  .form-floating {
    width: 100%;
  }
  input[type="text"] {
    width: 100%;
  }

  .form-control {
    height: 50px;
    box-shadow: none;
    outline: none;
    border-radius: 10px;
    border: 1px solid var(--border);
    background-color: ${({ bg }) => (bg ? bg : "var(--bgSecondary)")};
    &::placeholder {
      color: var(--textPlaceholder2);
    }
  }
  .form-control:focus {
    box-shadow: none;
    outline: none;
    border: 1px solid var(--border);
  }
  @media (max-width: 767px) {
    .formEleContainer {
      flex-wrap: wrap;
      gap: 3px;
      margin: 0;
      padding: 3px 0px 3px 0px;
      label {
        width: 100%;
      }
    }
  }
`;
